/** Creates a new lookup state with the corresponding actions.
 * @param VinLookpService service for vin lookup.
 * @paran initialVin initial VIN value.
 * @param onVinResult function of type (vin, make, model, year) => Unit.
 * @param onVinFailure function of type () = > Unit to invoke when vin was requested but not loaded;j
 */
define([], () => (VinLookupService, {initialVin, onVinResult, onVinFailure}) => {
    let loading = false;
    let vin = initialVin;

    function lookupVin() {
        if (loading) {
            return;
        }
        loading = VinLookupService.autofillBasedOnVIN('quoteandbind', vin).then(
            succ => {
                loading = false;
                if (succ && succ.make && succ.model && succ.year) {
                    onVinResult(vin, succ.make, succ.model, succ.year);
                } else {
                    onVinFailure();
                }
            },
            () => onVinFailure()
        );

    }

    return {
        get loading() {
            return loading;
        },
        get vin() {
            return vin;
        },
        set vin(newVin) {
            if (!loading) {
                vin = newVin;
            }
        },
        'lookup': lookupVin,
        'cancel': onVinFailure
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/vehicle/models/VinLookupState.js
 **/